import script from "./ThemeToggler.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeToggler.vue?vue&type=script&setup=true&lang=js"

import "./ThemeToggler.vue?vue&type=style&index=0&id=bf9ca3b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf9ca3b6"]])

export default __exports__